import { render } from "./wishlist-item.vue?vue&type=template&id=63cf7e3e"
import script from "./wishlist-item.vue?vue&type=script&setup=true&lang=js"
export * from "./wishlist-item.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/wishlist/wishlist-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63cf7e3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63cf7e3e', __exports__)) {
    api.reload('63cf7e3e', __exports__)
  }
  
  module.hot.accept("./wishlist-item.vue?vue&type=template&id=63cf7e3e", () => {
    api.rerender('63cf7e3e', render)
  })

}


export default __exports__